import { render } from "./BackgroundGray.vue?vue&type=template&id=00546ce3"
import script from "./BackgroundGray.vue?vue&type=script&lang=js"
export * from "./BackgroundGray.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__